import React, { useState } from "react";
import { useStateValue } from "../../StateProvider";
import { getDefaultValue } from "../../utils";
import { saveSupportMessage } from "../../utils/Network";

function HelpModal() {
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find((x) => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  const handleChange = (e) => {
    setDone(false);
    setError(false);
    switch (e.target.name) {
      case "title":
        setTitle(e.target.value);
        break;
      case "message":
        setMessage(e.target.value);
        break;
      default:
        break;
    }
  };

  const saveChanges = () => {
    setLoading(true);
    setError(false);
    setDone(false);

    if (message.length < 10) {
      setError(translate("Please Enter Message"));
      setLoading(false);
      return;
    }

    saveSupportMessage(title, message).then(() => {
      setLoading(false);
      setError(false);
      setTitle("");
      setMessage("");
      setDone(
        translate(
          "Message saved Successfully. we will be in touch as soon as possible."
        )
      );
    });
  };

  return (
    <div
      className="modal fade lan-rtl help-ticket-modal"
      id="helpModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="helpModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md-wide">
        <div className="modal-content bg-upload-material">
          <div className="modal-header modal-header--polished no-border ">
            <h2
              className="modal-title-polished lan-text-right"
              id="helpModalLabel"
            >
              
            </h2>
            <button
              type="button"
              className="close modal-close-ghost"
              data-dismiss="modal"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="modal-body lan-text-right bg-dark pt-3 pb-4 help-ticket-modal__body">
            <div className="form-group mb-3">
              
              <input
                id="help-ticket-subject"
                type="text"
                name="title"
                value={title}
                onChange={handleChange}
                className="form-control help-ticket-modal__input"
                placeholder={translate("Subject")}
                autoComplete="off"
              />
            </div>
            <div className="form-group mb-3">
              
              <textarea
                id="help-ticket-message"
                name="message"
                value={message}
                onChange={handleChange}
                className="form-control help-ticket-modal__textarea"
                rows={6}
                placeholder={translate("Message")}
              />
            </div>

            {error && (
              <div className="alert alert-danger help-ticket-modal__alert lan-text-right kfont">
                {error}
              </div>
            )}
            {loading && (
              <div className="alert alert-info help-ticket-modal__alert lan-text-right kfont mb-3">
                {translate("please wait...")}
              </div>
            )}
            {done && (
              <div className="alert alert-success help-ticket-modal__alert lan-text-right kfont mb-3">
                {done}
              </div>
            )}

            <button
              type="button"
              onClick={saveChanges}
              className="btn btn-block help-ticket-modal__submit text-uppercase font-weight-bold"
              disabled={loading}
            >
              <i className="fas fa-paper-plane op-7 mr-2" aria-hidden />
              {translate("SEND")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpModal;
